/* src/app/shared/components/session-expired/session-expired.component.scss */
.session-expired-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 40px;
  text-align: center;
  min-width: 280px;
}
.session-expired-icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #fdecea;
  display: flex;
  align-items: center;
  justify-content: center;
}
.session-expired-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #c0392b;
}
.session-expired-title {
  font-size: 1.2rem;
  font-weight: 600;
  font-family: inherit;
  color: #1a1a2e;
  margin: 0;
}
.session-expired-message {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
  line-height: 1.7;
  white-space: pre-wrap;
  text-align: center;
}
.session-expired-countdown {
  font-size: 15px !important;
  color: #bbb;
  margin: 0;
  letter-spacing: 0.3px;
}
/*# sourceMappingURL=session-expired.component.css.map */
